module.exports = __webpack_public_path__ + "cb625b3cd5bd6f13c01befc0e3982e53.jpg";